import { createPageNavigator } from "@-/dev.improve.haniverse.lib.navigator.page";
import { useCallback } from "react";

function useNavigator() {
  return useCallback(
    () => ({
      href: {
        pathname: "/(nav)/(app)/settings/offline-packs",
      },
      queries: [],
    }),
    [],
  );
}

export const useOfflinePacksSettingsPageNavigator = createPageNavigator<void>({
  useNavigator,
});
